import * as React from "react";
import { useDeepCompareCallback } from "use-deep-compare";
import { t } from "../../i18n/util";
import { API } from "../../network/API";
import { GetJobCategoriesResponse, JobCategory } from "../../network/APITypes";
import { generalStore } from "../../stores/GeneralStore";
import { GetJobCategoriesParams } from "../../types/models";

export const useJobCategories = (options?: GetJobCategoriesParams) => {
    const inFlight = React.useRef(false);

    const [jobCategories, setJobCategories] = React.useState<JobCategory[]>([]);
    const [initialLoaded, setInitialLoaded] = React.useState(false);
    const [total, setTotal] = React.useState(0);

    const loadJobCategories = useDeepCompareCallback(
        async () => {
            if (inFlight.current === true) {
                return;
            }

            try {
                generalStore.isLoading = true;
                inFlight.current = true;

                const response: GetJobCategoriesResponse = await API.getJobCategories(options);

                if (response && response.items) {
                    setJobCategories(response.items);
                    setTotal(response.total);
                }
            } catch (err) {
                generalStore.setError(t("error.loadJobCategories"), err);
            } finally {
                generalStore.isLoading = false;
                inFlight.current = false;
                setInitialLoaded(true);
            }
        },
        [options]
    );

    const reload = React.useCallback(() => {
        loadJobCategories();
    }, [loadJobCategories]);

    React.useEffect(() => {
        reload();
    }, [reload]);

    return {
        jobCategories,
        initialLoaded,
        total,
        reload
    };
};
